import React, { useEffect, useState } from "react";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import SelectDinamico from "../../../components/SelectDinamico";
import SelectCentroCusto from "../../../components/Select/CentroCusto";
import SelectArmazem from "../../../components/Select/Armazem";
import SelectFixo from "../../../components/SelectFixo";
import UploadFiles from "../../../components/UploadFiles";
import TrelloBoard from "../../../components/TrelloBoard";
import SubmitForm from "../../../components/SubmitForm";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { format, parse } from "date-fns";

import ContratoParceria from "../../../../lib/json/consultas/ContratoParceria.json"
import ConsultaCentroCusto from "../../../../lib/json/consultas/CentroCustoSelect.json"
import ConsultaContaContabil from "../../../../lib/json/consultas/ContaContabil.json"

import { ConsumoAPI_FileUpload } from "../../../../backend/ConsumoAPI";
import { ErroMsg, RetornaUsuarioLogado, SucessoMsg, calcularDiferencaEmDias, converteDataProtheus, formatDateColumnCard, formatarMoeda2, parseLocaleNumber } from "../../../contents/VariaveisGlobais";
import ConsultaTotvs from "../../../../backend/ConsultaTotvs";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import BuscaProduto from "../../../components/BuscaProduto";
import { LabelInput } from "../../../components/InputGeral/styles";
import { HRDivider } from "../../CRM/Cadastros/FichaEtapa/styles";
import SelectFinalidade from "../../../components/Select/Finalidade";
import { handleQtdUnitarioCard, handleValorTotalCard, handleObservacaoInterna, handleAnexos } from "../../../components/GridCell/Solicitacao";
import { handleCentroCustoLabel } from "../../../components/GridCell/Pedido";
import SelectFornecedor from "../../../components/Select/Fornecedor";
import SelectContaContabil from "../../../components/Select/ContaContabil";
import SelectMoeda from "../../../components/Select/Moeda";
import SelectCondicaoPagamento from "../../../components/Select/CondicaoPagamento";
import SelectComprador from "../../../components/Select/Comprador";

function FichaContratoParceria({idContratoParceria: propIdContratoParceria,
  empresaFilialCompras: propEmpresaFilialCompras,
  empresaFilialDestino: propEmpresaFilialDestino,
}) {
    const navigate = useNavigate();
    const currentDate = new Date()
    const isFormVisual = window.location.href.includes('Visualizar') || propIdContratoParceria;
    const isCopiar = window.location.href.includes('Copiar');
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus
    
    // const { idContratoParceria, itemContratoParceria, empresaFilialCompras, empresaFilialDestino } = useParams();
    const {
        idContratoParceria: urlId,
        empresaFilialCompras: urlEmpresaFilial,
        empresaFilialDestino: urlDestino
    } = useParams();

    // Use prop se existir, senão use o valor da URL
    const idContratoParceria = propIdContratoParceria ?? urlId;
    const empresaFilialCompras = propEmpresaFilialCompras ?? urlEmpresaFilial;
    const empresaFilialDestino = propEmpresaFilialDestino ?? urlDestino;
    
    const [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);
    const [disabledCabecalho, setDisabledCabecalho] = useState((isFormVisual || idContratoParceria));    
    const [empresaFilial, setEmpresaFilial] = useState();
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState();
    const [campoNumero, setCampoNumero] = useState( isCopiar ? "" : idContratoParceria);
    const [campoComprador, setCampoComprador] = useState({value: usuarioProtheus?.value || '', label: ''});
    const [campoFornecedor, setCampoFornecedor] = useState(null);
    const [campoDataEmissao, setCampoDataEmissao] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [campoTipoCompra, setCampoTipoCompra] = useState({value:'', label: 'Selecione a Finalidade'});
    const [campoPrioridade, setCampoPrioridade] = useState({value: '', text: 'Selecione a Prioridade' });
    const [campoDataInicial, setCampoDataInicial] = useState(format(currentDate, 'yyyy-MM-dd'))
    const [campoDataFinal, setCampoDataFinal] = useState(format(currentDate, 'yyyy-MM-dd'))
    const [campoMoeda, setCampoMoeda] = useState({value: '', label: 'Selecione a Moeda'});
    const [campoTipoFrete, setCampoTipoFrete] = useState({value: 'C', text: 'CIF'});
    const [campoCondicaoPagamento, setCampoCondicaoPagamento] = useState();
    const [campoAnexos, setCampoAnexos] = useState([]);
    
    const [campoItem, setCampoItem] = useState();
    const [campoProduto, setCampoProduto] = useState();
    const [campoUnidade, setCampoUnidade] = useState("");
    const [campoQuantidade, setCampoQuantidade] = useState(formatarMoeda2(0,2));
    const [campoValorUnitario, setCampoValorUnitario] = useState(formatarMoeda2(0,2));
    const [campoValorTotal, setCampoValorTotal] = useState(formatarMoeda2(0,2));
    const [campoPrazo, setCampoPrazo] = useState(0);
    const [campoCA, setCampoCA] = useState('');
    const [campoArmazem, setCampoArmazem] = useState({value: '', label: 'Selecione o Armazém'});
    const [campoCentroCusto, setCampoCentroCusto] = useState({value: '', label: 'Selecione o Centro de Custo'});
    const [campoContaContabil, setCampoContaContabil] = useState({value: '', label: 'Selecione a Conta Contabil'});
    const [campoDescricaoComplementar, setCampoDescricaoComplementar] = useState("");
    const [campoObservacaoInterna, setCampoObservacaoInterna] = useState("");
    const [campoObservacaoFornecedor, setCampoObservacaoFornecedor] = useState("");
    const [campoAnexosItem, setCampoAnexosItem] = useState([]);

    const [dataItensSolicitacao, setDataItensSolicitacao] = useState([]);
    
    const [queryProduto, setQueryProduto] = useState('');
    const [queryCentroCusto, setQueryCentroCusto] = useState('');
    const [queryContaContabil, setQueryContaContabil] = useState('');
    
    const [tipoCentroCusto, setTipoCentroCusto] = useState('');
    const [opcoesContaContabil, setOpcoesContaContabil] = useState([]);


    const options = [
        {
            value: '1',
            text: "Normal",
        },
        {
            value: '2',
            text: "Regularização",
        },
        {
            value: '3',
            text: "Emergencial",
        },
        {
            value: '5',
            text: "Reposição",
        },
        {
            value: '6',
            text: "Compra Direta",
        }
    ];

    const loadContratoParceria = async() => {
        
        if ( idContratoParceria ) {
            let consultaDefault = ContratoParceria.consulta;
        
            let cFiltro = "AND C3_FILIAL = FILIAL(SC3) ";
            cFiltro += "AND C3_NUM = '" + idContratoParceria + "' ORDER BY C3_ITEM ASC ";

            let cCampos = " , C3_TPFRETE, A2_CGC, C3_MOEDA, C3_PRODUTO, CASE WHEN B5_CEME != '' THEN B5_CEME ELSE B1_DESC END AS DESCRI, B1_DESC, C3_LOCAL, NNR_DESCRI, C3_CC"
            cCampos += " , CTT_DESC01, DHK_XPRDIN, DHK_XPRDFN, DHK_XDSLA, DHK_XGRPRD"
            cCampos += " , CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C3_XANXCP))) C3_XANXCP"
            cCampos += " , CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C3_XANEXO))) C3_XANEXO"
            cCampos += " , C3_ITEM, C3_UM, C3_QUANT, C3_PRECO, C3_TOTAL, C3_XPRAZO, C3_XCA, C3_OBS"
            cCampos += " , CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C3_XOBSINT))) C3_XOBSINT"
            cCampos += " , CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C3_XOBSFOR))) C3_XOBSFOR"

            consultaDefault = consultaDefault.replace("FILTRO", cFiltro)
            consultaDefault = consultaDefault.replace("CAMPOS", cCampos)

            setCarregar(true);
            var retConsulta = await ConsultaTotvs( consultaDefault, ContratoParceria.tabelas, empresaFilialCompras );

            if (empresaFilialDestino){
                setEmpresaFilialSelect(empresaFilialDestino) 
            }
            
            if (retConsulta.data){
                let aItens = []
                retConsulta.data.map( (item, index) => {
                    const prioridadeOption = options.filter( (option) => option.value === (item.C3_XFLUXCP.trim() || "1"))
                    const tipoFreteOption = item.C3_TPFRETE === 'C' ? 'CIF' : item.C3_TPFRETE === 'F' ? 'FOB' : ''
                    
                    let Comprador = {value: item.C3_USER, label: item.Y1_COD + ' - ' + item.Y1_NOME}
                    let Fornecedor = {value: item.C3_FORNECE + '' + item.C3_LOJA, label: item.C3_FORNECE + '/' + item.C3_LOJA + ' - ' + item.A2_NOME.trim() + '(' + item.A2_CGC.trim() + ')'}
                    let Moeda = {value: item.C3_MOEDA.toString(), label: ''} 
                    let Produto = {value: item.C3_PRODUTO, label: item.C3_PRODUTO + ' - ' + item.DESCRI, descricaoBD: item.B1_DESC } 
                    let Armazem = {value: (isCopiar ? "" : item.C3_LOCAL), label: (isCopiar ? "" :item.C3_LOCAL + ' - ' + item.NNR_DESCRI)}
                    let CentroCusto = {value: (isCopiar ? "" : item.C3_CC), label: (isCopiar ? "" : item.C3_CC + ' - ' + item.CTT_DESC01)}
                    let TipoFrete = {value: item.C3_TPFRETE, text: tipoFreteOption}
                    let Prioridade = {value: (item.C3_XFLUXCP.trim() || "1"), text: prioridadeOption[0].text }
                    let TipoCompra = {value: item.C3_XTIPCOM, label: item.C3_XTIPCOM + " - " + item.DHK_DESCR, origem: { DHK_XPRDIN: item.DHK_XPRDIN, DHK_XPRDFN: item.DHK_XPRDFN, DHK_XDSLA: item.DHK_XDSLA, DHK_XGRPRD: item.DHK_XGRPRD} } 
                    let CondicaoPagamento = {value: item.C3_COND, label: item.C3_COND + ' - ' + item.E4_DESCRI}
                    let cAnexoCP = item.C3_XANXCP.trim() || '[]'; //Campo Tabela Sistema
                    let dataEmissao = isCopiar ? format(currentDate, 'yyyy-MM-dd') : converteDataProtheus(item.C3_EMISSAO);
                    let dataIni = isCopiar ? format(currentDate, 'yyyy-MM-dd') :converteDataProtheus(item.C3_DATPRI);
                    let dataFim = isCopiar ? format(currentDate, 'yyyy-MM-dd') :converteDataProtheus(item.C3_DATPRF);
                    
                    setCampoComprador(Comprador);
                    setCampoFornecedor(Fornecedor)
                    setCampoDataEmissao(dataEmissao);
                    setCampoTipoCompra(TipoCompra);
                    setCampoPrioridade(Prioridade);
                    setCampoDataInicial(dataIni);
                    setCampoDataFinal(dataFim);
                    setCampoMoeda(Moeda);
                    setCampoTipoFrete(TipoFrete)
                    setCampoCondicaoPagamento(CondicaoPagamento)
                    setCampoAnexos( JSON.parse(cAnexoCP))
                    
                    if (item.DHK_XPRDIN || item.DHK_XPRDFN || item.DHK_XGRPRD){
                        let cQueryProduto = ''
                        

                        if (item.DHK_XGRPRD.trim().slice(0,-1)){
                            cQueryProduto += " AND B1_GRUPO IN ('" + item.DHK_XGRPRD.trim().slice(0,-1).replaceAll(';', "','") + "') "
                        }

                        setQueryProduto(cQueryProduto)
                    }
					
					handleRegraTipoCompra(TipoCompra)

                    let cAnexoItem = item.C3_XANEXO.trim() || '[]'; //Campo Tabela Sistema                        
                    
                    if ( index === 0 ){
                        let cFilial = item.C3_FILIAL
                        
                        setCampoItem(item.C3_ITEM)

                        if (!empresaFilialDestino){
                            setEmpresaFilialSelect("01"+cFilial) 
                        }
                        
                        setCampoProduto(Produto)
                        setCampoUnidade(item.C3_UM) 
                        setCampoQuantidade(formatarMoeda2(parseFloat(item.C3_QUANT),2)) 
                        setCampoValorUnitario(formatarMoeda2(parseFloat(item.C3_PRECO),2)) 
                        setCampoValorTotal(formatarMoeda2(parseFloat(item.C3_TOTAL),2)) 
                        setCampoPrazo(parseFloat(item.C3_XPRAZO)) 
                        setCampoCA(item.C3_XCA)
                        setCampoArmazem(Armazem)
                        setCampoCentroCusto(CentroCusto)
                        // setCampoContaContabil(ContaContabil)
                        setCampoDescricaoComplementar(item.C3_OBS) 
                        setCampoObservacaoInterna(item.C3_XOBSINT)
                        setCampoObservacaoFornecedor(item.C3_XOBSFOR)
                        setCampoAnexosItem( JSON.parse(cAnexoItem))                        
                    }

                    aItens.push({ numero: isCopiar ? "" : item.C3_NUM,
                            item: item.C3_ITEM,  
                            comprador: Comprador,
                            fornecedor: Fornecedor,
                            emissao: dataEmissao,
                            tipoCompra: TipoCompra,
                            prioridade: Prioridade,
                            dataIni: dataIni,
                            dataFim: dataFim,
                            moeda: Moeda,
                            tipoFrete: TipoFrete,
                            condicaoPagamento: CondicaoPagamento,
                            anexocp: cAnexoCP, //Campo Tabela Sistema
                            produto: Produto,
                            unidadeMedida: item.C3_UM, 
                            quantidade: formatarMoeda2(parseFloat(item.C3_QUANT),2), 
                            valorUnitario: formatarMoeda2(parseFloat(item.C3_PRECO),2), 
                            valorTotal: formatarMoeda2(parseFloat(item.C3_TOTAL),2), 
                            prazoDias: parseFloat(item.C3_XPRAZO), 
                            certificado: item.C3_XCA,
                            campoArmazem: Armazem,
                            campoCentroCusto: CentroCusto,
                            // campoContaContabil: ContaContabil,
                            descricaoComplementar: item.C3_OBS,
                            observacaoInterna: item.C3_XOBSINT, //Campo Tabela Sistema
                            observacaoFornecedor: item.C3_XOBSFOR, //Campo Tabela Sistema
                            anexoitem: cAnexoItem, //Campo Tabela Sistema
                            deletado: false
                    })
                });

                setDataItensSolicitacao(aItens);
            }

            setCarregar(false);
        }
    }

    useEffect( () => {
        const fetchData = async() => {
            await loadContratoParceria()
        }

        fetchData()
    }, []);

    const columnsItensSolicitacao = [
        {
            Header: 'Produto',
            accessor: 'produto.label',
        },
        {
            Header: 'Descrição Complementar',
            accessor: 'descricaoComplementar'
        },
        {
            Header: 'U. M.',
            accessor: 'unidadeMedida',
        },
        {
            Header: 'Qtde.',
            accessor: 'quantidade',
            render: handleQtdUnitarioCard
        },
        {
            Header: 'Valor Total',
            accessor: 'valorTotal',
            render: handleValorTotalCard
        },
        {
            Header: 'Prazo Entrega (Dias)',
            accessor: 'prazoDias',
        },
    ]

    const columnsAditional = [
        {
            Header: 'Centro de Custo',
            accessor: 'campoCentroCusto.label',
            render: handleCentroCustoLabel
        },
        {
            Header: 'Observação Interna',
            accessor: 'observacaoInterna',
            render: handleObservacaoInterna
        },
        {
            Header: 'Anexos Item',
            accessor: 'anexoitem',
            render: handleAnexos
        },
    ]

    const handleTipoCompra = (selectedOption) =>{
        setCampoTipoCompra(selectedOption)
        handleRegraTipoCompra(selectedOption)

        if (campoDataEmissao && selectedOption.value.trim() && campoPrioridade.value.trim()){
            setDisabledCabecalho(true)
        }
    }

    const handleRegraTipoCompra = (selectedOption) => {
        if (selectedOption?.origem){
            let item = selectedOption.origem;
    
            if (item.DHK_XPRDIN || item.DHK_XPRDFN || item.DHK_XGRPRD){
                let cQueryProduto = ''

                switch (selectedOption.value) {
                    case window._env_?.REACT_APP_FINALIDADE_APLICACAO:
                        cQueryProduto += " AND ( ( BM_XCTAVLO != '' AND BM_XCTAVLC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_CONSUMO:
                        cQueryProduto += " AND ( ( BM_XCTCONO != '' AND BM_XCTCONC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_LOCACOES:
                        cQueryProduto += " AND ( ( BM_XCTLOCO != '' AND BM_XCTLOCC != '' ) "                    
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_SERVICOS:
                        cQueryProduto += " AND ( ( BM_XCTSERO != '' AND BM_XCTSERC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_EPI:
                        cQueryProduto += " AND ( ( BM_XCTEPIO != '' AND BM_XCTEPIC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_REVENDA:
                        cQueryProduto += " AND ( ( BM_XCTREVO != '' AND BM_XCTREVC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_ATIVO:
                        cQueryProduto += " AND ( ( BM_XCTATVO != '' AND BM_XCTATVC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_BRINDE:
                        cQueryProduto += " AND ( ( BM_XCTBRNO != '' AND BM_XCTBRNC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_EXTRAVIO:
                        cQueryProduto += " AND ( ( BM_XCTIEXO != '' AND BM_XCTIEXC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_SUBSTITUICAO:
                        cQueryProduto += " AND ( ( BM_XCTISBO != '' AND BM_XCTISBC != '' ) "                    
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_MANUTENCAO:
                        cQueryProduto += " AND ( ( BM_XCTIMNO != '' AND BM_XCTIMNC != '' ) "
                        break;
                    default:
                        cQueryProduto += " AND ( ( 1 = 1  ) "
                        break;
                }
                
                if (item.DHK_XGRPRD.trim().slice(0,-1)){
                    cQueryProduto += " OR B1_GRUPO IN ('" + item.DHK_XGRPRD.trim().slice(0,-1).replaceAll(';', "','") + "')  "
                }
                
                cQueryProduto += " ) "
        
                setQueryProduto(cQueryProduto)
            }
        }
    }

    const handleProduto = (e) =>{
        if (e){
            // let contaProduto = e.origem.B1_CONTA
            let contabil = [
                { finalidade: 'Produto',                                        operacional: e.origem.B1_XCONTA,     corporativo: e.origem.B1_CONTA  },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_APLICACAO,       operacional: e.origem.BM_XCTAVLO,   corporativo: e.origem.BM_XCTAVLC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_CONSUMO,         operacional: e.origem.BM_XCTCONO,   corporativo: e.origem.BM_XCTCONC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_LOCACOES,        operacional: e.origem.BM_XCTLOCO,   corporativo: e.origem.BM_XCTLOCC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_SERVICOS,        operacional: e.origem.BM_XCTSERO,   corporativo: e.origem.BM_XCTSERC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_EPI,             operacional: e.origem.BM_XCTEPIO,   corporativo: e.origem.BM_XCTEPIC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_REVENDA,         operacional: e.origem.BM_XCTREVO,   corporativo: e.origem.BM_XCTREVC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_ATIVO,           operacional: e.origem.BM_XCTATVO,   corporativo: e.origem.BM_XCTATVC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_BRINDE,          operacional: e.origem.BM_XCTBRNO,   corporativo: e.origem.BM_XCTBRNC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_EXTRAVIO,        operacional: e.origem.BM_XCTIEXO,   corporativo: e.origem.BM_XCTIEXC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_SUBSTITUICAO,    operacional: e.origem.BM_XCTISBO,   corporativo: e.origem.BM_XCTISBC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_MANUTENCAO,      operacional: e.origem.BM_XCTIMNO,   corporativo: e.origem.BM_XCTIMNC }
            ]
            
            setCampoUnidade( (e.origem ? e.origem.B1_UM : '') )
            setCampoProduto( { value: e.value, label: e.label, descricaoBD: e.origem.B1_DESC } )
            // setOpcoesContaContabil(contabil);

            return
        }
        
        setCampoProduto()
        setCampoUnidade( "" )
        // setOpcoesContaContabil([]);        
    }

    const handleArmazem = (e) =>{
        let cConsulta = !e.origem ? "" : ConsultaCentroCusto.consulta + 
                                         " WHERE CTT_FILIAL = FILIAL(CTT) " + 
                                         " AND CTT.D_E_L_E_T_ <> '*'" +
                                         " AND CTT_CLASSE = '2'" +
                                         " AND CTT_BLOQ = '2'" +
                                         " AND CTT_CUSTO = '" + e.origem.NNR_XCC + "'"

        setQueryCentroCusto(cConsulta)
        setCampoArmazem( { value: e.value, label: e.label } )
        
        //Sempre que altera o Armazem, deve limpar o Centro de Custo e a Conta Contabil
        setCampoCentroCusto({value: '', label: 'Selecione o Centro de Custo'})
        // setTipoCentroCusto('')      
        // setCampoContaContabil({value: '', label: 'Selecione a Conta Contabil'});

        // setQueryContaContabil('')
    }

    const handleAddFilesCP = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];

        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC, TXT, planilhas do Excel ou arquivos CSV.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexos, ...newFiles]
            setCampoAnexos(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFilesCP = (fileDelete) => {
        const updatedFiles = [...campoAnexos];
        updatedFiles.splice(fileDelete, 1);

        setCampoAnexos(updatedFiles)
        return updatedFiles;
    }

    const handleAddFiles = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexosItem, ...newFiles]
            setCampoAnexosItem(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFiles = (fileDelete) => {
        const updatedFiles = [...campoAnexosItem];
        updatedFiles.splice(fileDelete, 1);
        
        setCampoAnexosItem(updatedFiles)
        return updatedFiles;
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    const handleCampoQuantidade = (e) => {
        const inputValue = e.target.value;

        if (/^(?:\d{1,3}(?:\.\d{3})*)(?:\,\d{0,2})?$/.test(inputValue) || inputValue === '') {
            const valorTotal = parseLocaleNumber(inputValue) * parseLocaleNumber(campoValorUnitario)
    
            setCampoQuantidade(formatarMoeda2(parseLocaleNumber(inputValue),2))
            setCampoValorTotal(formatarMoeda2(valorTotal,2))
        }
    }

    const handleCampoValorUnitario = (e) => {
        const inputValue = e.target.value;
        

        if (/^(?:\d{1,3}(?:\.\d{3})*)(?:\,\d{0,2})?$/.test(inputValue) || inputValue === '') {
            const valorTotal = parseLocaleNumber(inputValue) * parseLocaleNumber(campoQuantidade)

            setCampoValorUnitario(formatarMoeda2(parseLocaleNumber(inputValue),2))
            setCampoValorTotal(formatarMoeda2(valorTotal,2))
        }
    }

    const handleSaveItem = () => {
        if (!campoDataEmissao){
            ErroMsg("Selecione a Data de Emissão")
            return;
        }
        if (!campoTipoCompra.value.trim()){
            ErroMsg("Selecione a Finalidade")
            return;
        }
        if (!campoPrioridade.value.trim()){
            ErroMsg("Selecione a Prioridade")
            return;
        }
        if (!campoComprador){
            ErroMsg("Selecione o Comprador")
            return;
        }
        if (!campoProduto){
            ErroMsg("Selecione o Produto")
            return;
        }
        if (parseLocaleNumber(campoQuantidade) <=0){
            ErroMsg("Informe a quantidade");
            return;
        }
        if (parseLocaleNumber(campoValorTotal) <= 0) {
            ErroMsg("O valor total do item deve ser maior que zero.");
            return;
        }
        if (campoPrazo <= 0) {
            ErroMsg("O Prazo de Entrega em Dias do item deve ser maior que zero.");
            return;
        }
        if (campoTipoCompra.value === window._env_?.REACT_APP_FINALIDADE_EPI && !campoCA){
            ErroMsg("Informe o Certificado de Aprovação do EPI")
            return;
        }

        if (campoItem){
            const id = campoItem
            
            setDataItensSolicitacao((prevData) => {
                return prevData.map((item) => {
                    if (item.item === id){
                        return { ...item, 
                                comprador: campoComprador,
                                fornecedor: campoFornecedor,
                                emissao: campoDataEmissao,
                                tipoCompra: campoTipoCompra,
                                prioridade: campoPrioridade,
                                dataIni: campoDataInicial,
                                dataFim: campoDataFinal,
                                moeda: campoMoeda,
                                tipoFrete: campoTipoFrete,
                                condicaoPagamento: campoCondicaoPagamento,
                                anexocp: campoAnexos ? JSON.stringify(campoAnexos) : "",
                                produto: campoProduto,
                                unidadeMedida: campoUnidade, 
                                quantidade: campoQuantidade, 
                                valorUnitario: campoValorUnitario, 
                                valorTotal: campoValorTotal, 
                                prazoDias: campoPrazo, 
                                certificado: campoCA,
                                campoArmazem,
                                campoCentroCusto,
                                // campoContaContabil,
                                descricaoComplementar: campoDescricaoComplementar,
                                observacaoInterna: campoObservacaoInterna,
                                observacaoFornecedor: campoObservacaoFornecedor,
                                anexoitem: campoAnexosItem ? JSON.stringify(campoAnexosItem) : "",
                                deletado: false
                         };
                    }else{
                        return item;
                    } 
                })
            });

            setCampoItem('')
        }else{
            const dataLastItem = dataItensSolicitacao.findLast( (item) => item.item )
            const lastItem = parseFloat( dataLastItem ? dataLastItem.item : '0')
            const item = String(lastItem + 1)

            setDataItensSolicitacao(
                (prevData) => [...prevData, 
                    {   numero: "", 
                        item: item.padStart(4, '0'),
                        comprador: campoComprador,
                        fornecedor: campoFornecedor,
                        emissao: campoDataEmissao,
                        tipoCompra: campoTipoCompra,
                        prioridade: campoPrioridade,
                        dataIni: campoDataInicial,
                        dataFim: campoDataFinal,
                        moeda: campoMoeda,
                        tipoFrete: campoTipoFrete,
                        condicaoPagamento: campoCondicaoPagamento,
                        anexocp: campoAnexos ? JSON.stringify(campoAnexos) : "",
                        produto: campoProduto,
                        unidadeMedida: campoUnidade, 
                        quantidade: campoQuantidade, 
                        valorUnitario: campoValorUnitario, 
                        valorTotal: campoValorTotal, 
                        prazoDias: campoPrazo, 
                        certificado: campoCA,
                        campoArmazem,
                        campoCentroCusto,
                        // campoContaContabil,
                        descricaoComplementar: campoDescricaoComplementar,
                        observacaoInterna: campoObservacaoInterna,
                        observacaoFornecedor: campoObservacaoFornecedor,
                        anexoitem: campoAnexosItem ? JSON.stringify(campoAnexosItem) : "",
                        deletado: false
                    },
                ]
            );
        }

        clearForm()
    }

    const handleCancelItem = () => {
        clearForm();
    }

    const handleAlterarItem = (item) => {
        handleRegraTipoCompra(item.tipoCompra);
        
        setCampoItem(item.item)
        setCampoProduto(item.produto)
        setCampoUnidade(item.unidadeMedida)
        setCampoQuantidade(formatarMoeda2(parseLocaleNumber(item.quantidade),2))
        setCampoValorUnitario(formatarMoeda2(parseLocaleNumber(item.valorUnitario),2))
        setCampoValorTotal(formatarMoeda2(parseLocaleNumber(item.valorTotal),2))
        setCampoPrazo(item.prazoDias);
        setCampoCA(item.certificado)
        setCampoArmazem(item.campoArmazem)
        setCampoCentroCusto(item.campoCentroCusto)
        // setCampoContaContabil(item.campoContaContabil)
        setCampoDescricaoComplementar(item.descricaoComplementar)
        setCampoObservacaoInterna(item.observacaoInterna)
        setCampoObservacaoFornecedor(item.observacaoFornecedor)
        setCampoAnexosItem(JSON.parse(item.anexoitem))
    }

    const handleExcluirItem = (item) => {
        const id = item.item;

        setDataItensSolicitacao((prevData) => 
            prevData.map((item) => {
                if (item.item === id){
                    return { ...item, deletado: true };
                }else{
                    return item;
                }
            })
        );
    }

    const clearForm = () => {
        // setQueryContaContabil("")
        setQueryCentroCusto("")
        // setOpcoesContaContabil([])

        setCampoItem('')
        setCampoProduto();
        setCampoUnidade('');
        setCampoQuantidade(formatarMoeda2(0,2));
        setCampoValorUnitario(formatarMoeda2(0,2));
        setCampoValorTotal(formatarMoeda2(0,2));
        setCampoCA('');
        setCampoArmazem({value: '', label: 'Selecione o Armazém'});
        setCampoCentroCusto({value: '', label: 'Selecione o Centro de Custo'});
        // setCampoContaContabil({value: '', label: 'Selecione a Conta Contabil'});
        setCampoDescricaoComplementar('');
        setCampoObservacaoInterna('');
        setCampoObservacaoFornecedor('');
        setCampoAnexosItem([]);
    } 

    const handleSalvar = async() =>{
        let cJSONInclusao;
        let cJSONAlteracao;
        let oRetorno
        
        let dataItemInclusao = dataItensSolicitacao.filter( (item) => item.deletado === false && item.numero === "" )
        let dataItemAlteracao
        let dataItemExclusao

        if (campoNumero){
            dataItemAlteracao = dataItensSolicitacao.filter( (item) => item.deletado === false )
            dataItemExclusao = dataItensSolicitacao.filter( (item) => item.deletado === true && item.numero !== "" )
            
            //Atualiza o Data Item Inclusão, adicionando o Numero da CP
            dataItemAlteracao = dataItemAlteracao.map((item) => {
                return {
                    ...item, // mantém o que já existe
                    numero: campoNumero,
                    condicaoPagamento: campoCondicaoPagamento,
                    dataIni: campoDataInicial,
                    dataFim: campoDataFinal,
                    moeda: campoMoeda,
                    tipoFrete: campoTipoFrete
                }
            })

            if (dataItemAlteracao.length > 0){
                cJSONAlteracao = JSON.stringify(dataItemAlteracao)
            }

            dataItemInclusao = []
        }

        if (dataItemInclusao.length > 0){
            cJSONInclusao = JSON.stringify(dataItemInclusao)
        }
                
        setCarregar(true)
        if (dataItemExclusao){
            dataItemExclusao.forEach( async(element) => {
                const cJSONExclusao = { 
                    Numero: element.numero,
                    Item: element.item,
                    Fornecedor: element.fornecedor.value
                }

                oRetorno = await ConsumoTOTVS_POST('EXCLUIRCONTRATOPARCERIA', cJSONExclusao, empresaFilial)
            });
        }
        if (cJSONInclusao){
            oRetorno = await ConsumoTOTVS_POST('NOVOCONTRATOPARCERIA', cJSONInclusao, empresaFilial)
        }
        if (cJSONAlteracao){
            oRetorno = await ConsumoTOTVS_POST('ALTERARCONTRATOPARCERIA', cJSONAlteracao, empresaFilial)
        }
        
        setCarregar(false)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
            return false
        }
    }

    const handleCampoCentroCusto = (e) => {
        setCampoCentroCusto({ value: e.value, label: e.label })
        // setTipoCentroCusto(e.origem.CTT_XTIPO.trim())
    }

    // useEffect( () => {
    //     if (campoTipoCompra && tipoCentroCusto && opcoesContaContabil.length > 0){
    //         const contaProduto = (tipoCentroCusto === "1" ? opcoesContaContabil[0].operacional : opcoesContaContabil[0].corporativo)
            
    //         if (contaProduto){
    //             let cConsulta = ConsultaContaContabil.consulta + 
    //                             " WHERE CT1_FILIAL = FILIAL(CT1) AND D_E_L_E_T_ != '*' " + 
    //                             " AND CT1_CONTA = '" + (contaProduto) + "'"
                
    //             // setQueryContaContabil(cConsulta)
    //         }else{
    //             let opcaoContaProduto = opcoesContaContabil.filter( (item) => item.finalidade === campoTipoCompra.value )

    //             if (opcaoContaProduto && opcaoContaProduto.length > 0){
    //                 let contaProduto = ( tipoCentroCusto === "1" ? opcaoContaProduto[0].operacional : opcaoContaProduto[0].corporativo)
    //                 let cConsulta = ConsultaContaContabil.consulta + 
    //                                 " WHERE CT1_FILIAL = FILIAL(CT1) AND D_E_L_E_T_ != '*' " + 
    //                                 " AND CT1_CONTA = '" + (contaProduto) + "'"
                    
    //                 setQueryContaContabil(cConsulta)
    //             }else{
    //                 let cConsulta = ConsultaContaContabil.consulta + 
    //                                 " WHERE CT1_FILIAL = FILIAL(CT1) " +
    //                                 " AND D_E_L_E_T_ != '*' " +
    //                                 " AND CT1_CONTA = '' "
    //                 // setCampoContaContabil({value: '', label: 'Selecione a Conta Contabil'})
    //                 setQueryContaContabil(cConsulta)
    //             }
    //         }
    //     }
    // }, [campoTipoCompra, opcoesContaContabil, campoArmazem, tipoCentroCusto])

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text={`Contrato de Parceria ${isFormVisual ? ' - ' + idContratoParceria : ''}`}
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial && (
                <>
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Dados do Contrato Parceria: </h5>
                        </Col>
                    </Row>

                    <Row>
                        { campoNumero && //não está aparecendo na ficha
                            <>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Numero CP"
                                        placeholder="Numero CP"
                                        tipo="text"
                                        value={campoNumero}
                                        onChange={(e) => setCampoNumero(e)}
                                        disabled={true}
                                    />
                                </Col>
                            </>
                        }
                        <Col md="3" xs="12">
                            <SelectComprador
                                campoComprador={campoComprador}
                                changeComprador={setCampoComprador}
                                empresaLogada={empresaFilial}
                                disabled={disabledCabecalho}
                            />
                        </Col>
                        <Col md="5" xs="12">
                            <SelectFornecedor
                                campoFornecedor={campoFornecedor}
                                changeFornecedor={setCampoFornecedor}
                                empresaLogada={empresaFilial}
                                returnOriginal={true}
                                disabled={disabledCabecalho}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Data de Emissão"
                                placeholder="Data de Emissão"
                                tipo="date"
                                value={campoDataEmissao}
                                onChange={(e) => setCampoDataEmissao(e.target.value)}
                                disabled={true}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4" xs="12">
                            <SelectFinalidade
                                campoFinalidade={campoTipoCompra}
                                changeFinalidade={handleTipoCompra}
                                empresaLogada={empresaFilial}
                                returnOriginal={true}
                                filtraFilial={true}
                                showNoFilter={true}
                                disabled={disabledCabecalho && campoTipoCompra?.value.trim()}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <SelectFixo
                                options={options} 
                                value={campoPrioridade} 
                                selectedOptionValue={campoPrioridade} 
                                isLabel={true} 
                                label="Prioridade" 
                                onChange={(e) => setCampoPrioridade(e)}
                                disabled={disabledCabecalho && campoPrioridade?.value.trim()}
                            />
                        </Col>
                        <Col md="2" xs="12"> 
                            <InputGeral
                                label="Data Inicio"
                                placeholder="Data Inicio"
                                tipo="date"
                                value={campoDataInicial}
                                onChange={(e) => setCampoDataInicial(e.target.value)}
                                disabled={disabledForm}
                                min={campoDataEmissao}
                            />
                        </Col>
                        <Col md="2" xs="12"> 
                          <InputGeral
                                label="Data Fim"
                                placeholder="Data Fim"
                                tipo="date"
                                value={campoDataFinal}
                                onChange={(e) => setCampoDataFinal(e.target.value)}
                                disabled={disabledForm}
                                min={campoDataEmissao}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <SelectMoeda
                                campoMoeda={campoMoeda}
                                changeMoeda={setCampoMoeda}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectFixo 
                                options={[{
                                    value: 'C',
                                    text: "CIF",
                                },
                                {
                                    value: 'F',
                                    text: "FOB",
                                }]}
                                isLabel={true} 
                                label="Tipo Frete"
                                onChange={(e) => setCampoTipoFrete(e)}
                                selectedOptionValue={campoTipoFrete}
                                value={campoTipoFrete}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectCondicaoPagamento
                                campoCondPagto={campoCondicaoPagamento}
                                changeCondPagto={setCampoCondicaoPagamento}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <LabelInput>Anexo CP</LabelInput>
                            <UploadFiles 
                                onDropEvent={handleAddFilesCP}
                                onDeleteEvent={handleDelFilesCP}
                                value={campoAnexos}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    
                    { (campoDataEmissao && campoTipoCompra.value.trim() && campoPrioridade.value.trim()) && !disabledForm && (
                        <>
                            <HRDivider/>
                            <Row>
                                <Col md="10" xs="12">
                                    <h5>Dados Itens: </h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="7" xs="12">
                                    <BuscaProduto 
                                        empresaFilial={empresaFilial} 
                                        handleProduto={handleProduto} 
                                        campoProduto={campoProduto}
                                        queryComplemento={queryProduto}
                                    />
                                </Col>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Unid. Medida"
                                        placeholder="U.Medida"
                                        tipo="text"
                                        value={campoUnidade}
                                        onChange={(e) => setCampoUnidade(e.target.value)}
                                        disabled={true}
                                    />
                                </Col>
                                { campoTipoCompra && campoTipoCompra.value === window._env_?.REACT_APP_FINALIDADE_EPI && (
                                    <Col md="3" xs="12">
                                        <InputGeral
                                            label={"CA"}
                                            placeholder={"Certificado de Aprovação"}
                                            tipo="text"
                                            value={campoCA}
                                            onChange={(e) => setCampoCA(e.target.value)}                                            
                                        />
                                    </Col>
                                )}
                            </Row>
                            <Row>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Quantidade"
                                        placeholder="Quantidade"
                                        tipo="monetario"
                                        decimal={2}
                                        value={campoQuantidade}
                                        onChange={(e) => handleCampoQuantidade(e)}
                                    />
                                </Col>
                                <Col md="3" xs="12">
                                    <InputGeral
                                        label="Valor Unitário"
                                        placeholder="Valor Unitário"
                                        tipo="monetario"
                                        value={campoValorUnitario}
                                        onChange={(e) => handleCampoValorUnitario(e)}
                                        decimal={2}
                                    />
                                </Col>
                                <Col md="4" xs="12">
                                    <InputGeral
                                        label="Valor Total"
                                        placeholder="Valor Total"
                                        tipo="monetario"
                                        value={campoValorTotal}
                                        disabled={true}
                                        onChange={(e) => setCampoValorTotal(e)}
                                    />
                                </Col>
                                <Col md="3" xs="12">
                                    <InputGeral
                                        label={"Prazo Entrega (Dias)"}
                                        placeholder={"Prazo Entrega (Dias)"}
                                        tipo="numero"
                                        value={campoPrazo}
                                        onChange={(e) => setCampoPrazo(e.target.value)}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" xs="12">
                                    <SelectArmazem
                                        campoLocalEstoque={campoArmazem}
                                        changeLocalEstoque={handleArmazem}
                                        empresaLogada={empresaFilial}
                                        filtraFilial={true}
                                        returnOriginal={true}
                                        showNoFilter={true}
                                        disabled={!campoProduto} //o campo Armazém só funciona se o campo Produto estiver preenchido
                                    />
                                </Col>
                                <Col md="6" xs="12">
                                    <SelectCentroCusto 
                                        campoCentroCusto={campoCentroCusto}
                                        changeCentroCusto={handleCampoCentroCusto}
                                        empresaLogada={empresaFilial}
                                        queryCentroCusto={queryCentroCusto}
                                        loadDefault={false}
                                        returnOriginal={true}
                                        disabled={true}
                                        filtraFilial={true}
                                    />
                                </Col>
                                {/* <Col md="4" xs="12">
                                    <SelectContaContabil
                                        campoContaContabil={campoContaContabil}
                                        changeContaContabil={setCampoContaContabil}
                                        queryContaContabil={queryContaContabil}
                                        empresaLogada={empresaFilial}
                                        disabled={true}
                                        loadDefault={true}
                                        selectUnique={true}
                                    />
                                </Col> */}
                            </Row>
                            <HRDivider/>
                            <Row>
                                <Col md="12" xs="12">
                                    <InputGeral
                                        label="Descrição Complementar"
                                        placeholder="Descrição Complementar"
                                        tipo="text"
                                        value={campoDescricaoComplementar}
                                        onChange={(e) => setCampoDescricaoComplementar(e.target.value)}
                                        />
                                </Col>
                                <Col md="12" xs="12">
                                    <InputGeral
                                        label="Observação Interna"
                                        placeholder="Observação Interna"
                                        tipo="textArea"
                                        value={campoObservacaoInterna}
                                        onChange={(e) => setCampoObservacaoInterna(e.target.value)}
                                    />
                                </Col>
                                <Col md="12" xs="12">
                                    <InputGeral
                                        label="Observação ao Fornecedor"
                                        placeholder="Observação Fornecedor"
                                        tipo="textArea"
                                        value={campoObservacaoFornecedor}
                                        onChange={(e) => setCampoObservacaoFornecedor(e.target.value)}
                                    />
                                </Col>
                                <Col md="12" xs="12">
                                    <LabelInput>Anexo Item CP</LabelInput>
                                    <UploadFiles 
                                        onDropEvent={handleAddFiles}
                                        onDeleteEvent={handleDelFiles}
                                        value={campoAnexosItem}
                                    />
                                </Col>
                            </Row>

                            <Row className="d-flex align-content-end align-items-end justify-content-end">
                                <Col md="2" xs="12" >
                                    <Button variant="primary" className="w-100" onClick={handleSaveItem}>
                                        { campoItem && '✓ Salvar' || '✚ Adicionar' }
                                    </Button>
                                </Col>
                                <Col md="2" xs="12" >
                                    <Button variant="warning" className="w-100" onClick={handleCancelItem}>
                                        ✗ Cancelar
                                    </Button>                    
                                </Col>
                            </Row>
                        </>
                    )}
                </>
            )}
            { dataItensSolicitacao && dataItensSolicitacao.length > 0 &&
                <TrelloBoard 
                    columns={columnsItensSolicitacao} 
                    data={dataItensSolicitacao.filter((item) => item.deletado === false)} 
                    titleLista="Item: "
                    columnsAditional={columnsAditional}
                    buttons= { disabledForm ? [] : 
                            [   {action: handleAlterarItem, label: "Alterar", icone: "MdOutlineEditNote", style: "outline-info"},
                                {action: handleExcluirItem, label: "Excluir", icone: "MdPlaylistRemove", style: "outline-danger" }
                            ]
                    }
                    tamanhoCard="55lvh"
                />
            }
            { dataItensSolicitacao && dataItensSolicitacao.length > 0 && !propIdContratoParceria &&
                <SubmitForm 
                    onSave={ disabledForm ? null : handleSalvar}
                    onCancel={ disabledForm ? null : 'handleVoltar'}
                    onVoltar={ disabledForm ? 'handleVoltar' : null}
                />
            }
        </>
    );
}

export default FichaContratoParceria;